<template>
  <div id="TextEditor" :class="{'is-compact': reportValue=='6'||reportValue=='公司研究'}">
    <!-- <div v-html="accumulatedHtml"></div> -->
    <div id="TextEditorNav">
      <div ref="toolbarContainer"></div>
    </div>
    <div id="TextEditorMain">
      <div id="TextEditorMainCode">
        <div ref="textContainer"></div>
      </div>
      <!--      <div id="TextEditorMainShow" v-html="articleHtml"></div>-->
    </div>
    <el-dialog
    v-model="dialogVisible"
    title="替换详细信息"
    width="700"
    :before-close="handleClose"
  >
    <div style="min-height: 200px;" v-html="accumulatedHtml"></div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="sureClick" size="mini">确认</el-button>
      </div>
    </template>
  </el-dialog>
  </div>
</template>

<script>
import WangEditor from "wangeditor"
import DialogBox from "./Dialong.vue"
import {
  findByBlockTrade,
  findByTradingPost,
  findByZzIndustry,
  findBySzIndustry,
  findByCalculationSummary,
  findByCalculationSummaryYear,
  findByProfitDistribution,
  findByProfitDistributionYear,
  findByCashFlow,
  findByCashFlowYear,
  findByBeInDebt,
  findByBeInDebtYear,
  findByAdjustingFactor,
  findByTradingHaltInfo,
  findStockDetail,
  getkline,
  getfundflow,
} from "./imgApi.js"
import { ElMessage } from "element-plus"
import { stockInfo, findByBlockTradeTable, summaryTable } from "./getData.js"
import {
  summaryTableColumn,
  profitCloumn,
  cashFlowCloumn,
  flowCloumn,
} from "./tableColumn.js"
import { dealCodeSearch } from "../../views/course-manage/trade-manage/tradeMethods"

// 设置菜单
const menus = [
  "head",
  "bold",
  "fontSize",
  "fontName",
  "italic",
  "underline",
  "strikeThrough",
  "indent",
  "lineHeight",
  "foreColor",
  "backColor",
  "link",
  "todo",
  "justify",
  "quote",
  "emoticon",
  "image",
  "splitLine",
]

const LOCAL_BASE_URL = "/api"
export default {
  name: "TextEditor",
  data() {
    return {
      articleHtml: "",
      editor: null,
      dialogVisible: false,
      accumulatedHtml :'',
      period:'',
    }
  },
  components: {
    DialogBox,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    //获取编辑栏是否禁用
    disable: {
      type: Boolean,
    },
    //获取行业
    industry: {
      type: Number,
      default: null,
    },
    codeList: {
      type: Array,
      default: () => {
        return []
      },
    },
    reportValue: {
    type: String,
    default: '',
  },
  },
  watch: {
    value(val) {
      if (val !== this.editor.txt.html()) this.editor.txt.html(val)
      // this.editor.selection.moveCursor(this.editor.$textElem.elems[0],false);
    },
  },
  mounted() {
    const { $, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip } =
      WangEditor

    let _this = this
    class Head extends DropListMenu {
      constructor(editor) {
        // 菜单栏中，标题菜单的 DOM 元素
        // 注意，这里的 $ 不是 jQuery ，是 E.$ （wangEditor 自带的 DOM 操作工具，类似于 jQuery）
        // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
        const $elem = $(
          `<div class="w-e-menu" data-title="结构化图表"><div class="w-line"></div></div>`
        )

        // droplist 配置
        const dropListConf = {
          width: 100,
          title: "",
          type: "list",
          list: [
            { $elem: $("<div>日行情表-k线图</div>"), value: "d" },
            { $elem: $("<div>周行情表-k线图</div>"), value: "w" },
            { $elem: $("<div>月行情表-k线图</div>"), value: "m" },
            { $elem: $("<div>年行情表-k线图</div>"), value: "y" },
            {
              $elem: $("<div>复权因子表</div>"),
              value: "复权因子表",
            },
            {
              $elem: $("<div>股票交易资金流向</div>"),
              value: "股票交易资金流向",
            },
            {
              $elem: $("<div>大宗交易意向申报表</div>"),
              value: "大宗交易意向申报表",
            },
            // {
            //   $elem: $("<div>停牌复牌表</div>"),
            //   value: "停牌复牌表",
            // },
            {
              $elem: $("<div>行业市盈率_深证发布表</div>"),
              value: "行业市盈率_深证发布表",
            },
            {
              $elem: $("<div>行业市盈率_中证发布表</div>"),
              value: "行业市盈率_中证发布表",
            },
            {
              $elem: $("<div>季度财务汇总表</div>"),
              value: "季度财务汇总表",
            },
            {
              $elem: $("<div>单季利润表</div>"),
              value: "单季利润表",
            },
            {
              $elem: $("<div>单季现金流量表</div>"),
              value: "单季现金流量表",
            },
            {
              $elem: $("<div>单季资产负债表</div>"),
              value: "单季资产负债表",
            },
            {
              $elem: $("<div>年度财务汇总表</div>"),
              value: "年度财务汇总表",
            },
            {
              $elem: $("<div>年度利润表</div>"),
              value: "年度利润表",
            },
            {
              $elem: $("<div>年度现金流量表</div>"),
              value: "年度现金流量表",
            },
            {
              $elem: $("<div>年度资产负债表</div>"),
              value: "年度资产负债表",
            },

            // findByCalculationSummary
            // {
            //   $elem: $("<div>交易所日公开信息</div>"),
            //   value: "交易所日公开信息",
            // },
          ],

          // droplist 每个 item 的点击事件
          clickHandler: (value) => {
            // value 参数即 dropListConf.list 中配置的 value
            this.command(value)
          },
        }

        super($elem, editor, dropListConf)
      }

      command(value) {
        _this.getImage(this, value)
        // 设置标题
      }

      // 菜单是否需要激活
      tryChangeActive() {
        const reg = /^h/i
        const cmdValue = this.editor.cmd.queryCommandValue("formatBlock")
        if (reg.test(cmdValue)) {
          // 选区处于标题内，激活菜单
          this.active()
        } else {
          // 否则，取消激活
          this.unActive()
        }
      }
    }
    class AlertMenu extends BtnMenu {
      constructor(editor) {
        // 创建菜单 DOM 元素
        const $elem = $(`<div class="w-e-menu" data-title="替换">
      <div class="w-line"></div>
    </div>`)

        // 调用父类构造函数
        super($elem, editor)
      }

      // 菜单点击事件
      async clickHandler(editor, value) {
        _this.editor.selection.restoreSelection()
        _this.getAI()
      }
      tryChangeActive() {}
    }
    // 设置工具栏和编辑区分开
    this.editor = new WangEditor(
      this.$refs.toolbarContainer,
      this.$refs.textContainer
    )
    const editor = this.editor
    // 设置编辑器层级
    editor.config.zIndex = 1
    // 设置内容变化事件
    editor.config.onchange = (newHtml) => {
      this.onChange(newHtml)
    }
    // 设置placeholder
    editor.config.placeholder = "请输入公告内容"
    // 图片菜单配置
    editor.config.menus = menus
    editor.menus.extend("insertDrop", Head)
    editor.menus.extend("insertAI", AlertMenu)

    editor.config.menus = editor.config.menus.concat("insertABC")
    editor.config.menus = editor.config.menus.concat("insertDrop")
    editor.config.menus = editor.config.menus.concat("insertAI")

    // 图片上传配置
    //隐藏插入网络图片的功能
    editor.config.showLinkImg = false
    // 去除网络图片说明
    editor.config.showLinkImgAlt = false
    // 去除网络图片超链接跳转地址
    editor.config.showLinkImgHref = false
    editor.config.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
    editor.config.uploadImgShowBase64 = true // base 64 存储图片
    // 创建富文本实例
    editor.create()
    //内容回显
    editor.txt.html(this.value)
    //判断是否禁用编辑栏
    if (this.disable) {
      editor.disable()
    }
  },
  methods: {
    handleClose(){
      this.dialogVisible=false;
    },
    sureClick(){
     
      this.editor.cmd.do("insertHTML",  this.accumulatedHtml)
      this.dialogVisible=false;
    },
     isValidHTML5(tag) {
    // 正则表达式匹配标准 HTML 标签，包括起始和结束标签
    const validTagRegex = /^<\/?[a-z][a-z0-9]*( [^<>]+)?>.*<\/?[a-z][a-z0-9]*>$/i;
    const leftTagRegex = /^<([a-z][a-z0-9]*)( [^<>]+)?>$/i;
    const rightTagRegex = /^<\/?([a-z][a-z0-9]*)( [^<>]+)?>$/i;
    // 处理常见的不完整标签情况
    const incompleteTagPatterns = [
      /^<[a-z][a-z0-9]*$/,         // `<tag` 开头但未闭合
      /^<[a-z][a-z0-9]*\/$/,       // `<tag/` 但格式不标准
      /^[a-z][a-z0-9]*>$/,         // `tag>` 缺少 `<`
      /^[a-z][a-z0-9]*\/>$/,       // `tag/>` 缺少 `<`
      /^<\/?[a-z][a-z0-9]*[^<>]*$/ // `<tag` 或 `</tag` 开头但未正确闭合
    ];

    // 如果匹配不完整的标签模式，返回 false
    if (incompleteTagPatterns.some(pattern => pattern.test(tag))) {
      return false;
    }

    // 判断是否符合完整的 HTML 结构
    return validTagRegex.test(tag)||leftTagRegex.test(tag)||rightTagRegex.test(tag);
  },
    unescapeHtml(htmlString) {
      // 使用正则表达式替换转义的字符
      return htmlString
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    },
  async  getAI(){
    let _this=this;
     
        // 获取选中内容
        const selectedText = _this.editor.selection.getSelectionText()
        // 如果选中内容为空，提示用户
        if (selectedText.trim() === "") {
        } else {
          try {
            _this.dialogVisible=true;
            
            const accessToken = sessionStorage.getItem("token");
           let url = "/ailab/stream_generate_report_new?content="+selectedText;
           _this.accumulatedHtml = "";
            const res = await fetch(url, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: accessToken,
              },
            })
            if (!res.body || !window.ReadableStream) {
              data.valueEdit = await res.text()
              // valueDo.value.editor.cmd.do( "insertHTML",text)
              return
            }
            const reader = res.body.getReader()
            let decoder = new TextDecoder()
            let done = false
            
            while (!done) {
              const { value, done: doneReading } = await reader.read()
              done = doneReading
              if (value) {
                // 去除首行 ```html
                let chunk = decoder.decode(value)
                _this.accumulatedHtml +=chunk; 
                _this.accumulatedHtml =(( _this.accumulatedHtml.replace(/```html/g, "")).replace(/<style[^>]*>[\s\S]*?<\/style>/gi, ""))
                // const fixedHtml = _this.unescapeHtml(_this.accumulatedHtml);
                // console.log(_this.isValidHTML5(_this.accumulatedHtml),_this.accumulatedHtml,'8888s')
                // if(_this.isValidHTML5(_this.accumulatedHtml)){
                //   _this.editor.cmd.do("insertHTML", _this.accumulatedHtml)
                console.log(_this.accumulatedHtml,'8888s')
                // }
              } else {
                // _this.editor.cmd.do("insertHTML",  _this.accumulatedHtml )
             
                // 
              }
            }
          } catch (err) {}

          // alert(`选中的内容是：${selectedText}`);
        }
    },
    isHtmlTagComplete(htmlString) {
      const tagRegex = /<[^>]+>/g;
      const tags = htmlString.match(tagRegex);

      if (!tags) return false;

      const openTags = tags.filter(tag => tag[0] !== '/' && !tag.match(/\/>/));
      const closeTags = tags.filter(tag => tag[1] === '/');

      for (let openTag of openTags) {
        const closeTag = closeTags.find(tag => tag === `</${openTag.slice(1, -1)}`);
        if (!closeTag) return false;
      }

      return true;
    },
  
    getTime(day) {
      let today = new Date()
      let twoMonthsAgo = new Date(today)
      twoMonthsAgo.setDate(today.getDate() - day)
      return twoMonthsAgo.toISOString().slice(0, 10).replace(/-/g, "")
    },

    async getImage(val, period) {
      this.period=period;
      if (period == "大宗交易意向申报表") {
        this.setByBlock(val)
      } else if (period == "行业市盈率_中证发布表") {
        // this.setByTradingPost(val)
        this.setByZzIndustry(val)
      } else if (period == "行业市盈率_深证发布表") {
        this.setBySzIndustry(val)
      } else if (period == "季度财务汇总表" || period == "年度财务汇总表") {
        this.setfindByCalculationSummary(val, period)
      } else if (period == "单季利润表" || period == "年度利润表") {
        this.setfindByProfitDistribution(val, period)
      } else if (period == "单季现金流量表" || period == "年度现金流量表") {
        this.setFindByCashFlow(val, period)
      } else if (period == "复权因子表") {
        this.setFindByAdjustingFactor(val)
      } else if (period == "单季资产负债表" || period == "年度资产负债表") {
        this.setFindByBeInDebt(val, period)
      } else if (period == "停牌复牌表") {
        this.setFindByTradingHaltInfo(val)
      } else {
        this.setkLine(val, period)
      }
    },
    //单季资产负债表
    setFindByBeInDebt(val, type) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let data = {
        innerCodes: this.setCode(),
      }
      if (type == "年度资产负债表") {
        findByBeInDebtYear(data).then((res) => {
          if (res.status == 200) {
            let tableData = []
            res.data.forEach((item) => {
              item.list = []
              if (item.date.length > 0) {
                item.list = item.date[0].list
                // item.quarter=item.year
              }

              item.quarter = item.year
              if (item.list.length > 0) {
                tableData.push(item)
              }
            })
            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, flowCloumn, 3)
            )
          }
        })
      } else {
        findByBeInDebt(data).then((res) => {
          if (res.status == 200) {
            let tableData = res.data
            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, flowCloumn, 3)
            )
          }
        })
      }
    },
    //单季现金流量表
    setFindByCashFlow(val, type) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let data = {
        innerCodes: this.setCode(),
      }
      if (type == "年度现金流量表") {
        // data.reportType=0;
        findByCashFlowYear(data).then((res) => {
          if (res.status == 200) {
            let tableData = []
            res.data.forEach((item) => {
              item.list = []
              if (item.date.length > 0) {
                item.list = item.date[0].list
                // item.quarter=item.year
              }

              item.quarter = item.year
              if (item.list.length > 0) {
                tableData.push(item)
              }
            })
            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, cashFlowCloumn, 3)
            )
          }
        })
      } else {
        findByCashFlow(data).then((res) => {
          if (res.status == 200) {
            let tableData = res.data
            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, cashFlowCloumn, 3)
            )
          }
        })
      }
    },
    //单季利润表
    setfindByProfitDistribution(val, type) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let data = {
        innerCodes: this.setCode(),
      }
      if (type == "年度利润表") {
        findByProfitDistributionYear(data).then((res) => {
          if (res.status == 200) {
            let tableData = []
            res.data.forEach((item) => {
              item.list = []
              if (item.date.length > 0) {
                item.list = item.date[0].list
                // item.quarter=item.year
              }

              item.quarter = item.year
              if (item.list.length > 0) {
                tableData.push(item)
              }
            })
            console.log(tableData, "tableData")
            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, profitCloumn, 2)
            )
          }
        })
      } else {
        findByProfitDistribution(data).then((res) => {
          if (res.status == 200) {
            let tableData = res.data
            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, profitCloumn, 2)
            )
          }
        })
      }
    },
    //财务汇总表
    setfindByCalculationSummary(val, type) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let data = {
        innerCodes: this.setCode(),
      }
      if (type == "年度财务汇总表") {
        findByCalculationSummaryYear(data).then((res) => {
          console.log(res, "res111")
          if (res.status == 200) {
            let tableData = []
            res.data.forEach((item) => {
              item.list = []
              if (item.date.length > 0) {
                item.list = item.date[0].list
                // item.quarter=item.year
              }

              item.quarter = item.year
              if (item.list.length > 0) {
                tableData.push(item)
              }
            })

            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, summaryTableColumn)
            )
          }
        })
      } else {
        findByCalculationSummary(data).then((res) => {
          console.log(res, "res111")
          if (res.status == 200) {
            let tableData = res.data;
            if(!(tableData&&tableData.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
            val.editor.cmd.do(
              "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
              summaryTable(tableData, summaryTableColumn)
            )
          }
        })
      }
    },
    getToday(num) {
      // 获取今天的日期
      const today = new Date()

      // 获取前一天的日期
      const yesterday = new Date(today)
      yesterday.setDate(today.getDate() - num)

      // 格式化日期为 YYYY-MM-DD 格式
      const year = yesterday.getFullYear()
      const month = String(yesterday.getMonth() + 1).padStart(2, "0") // 月份从 0 开始，需要加 1
      const day = String(yesterday.getDate()).padStart(2, "0")

      const formattedYesterday = `${year}-${month}-${day}`
      if (num) {
        return formattedYesterday
      } else {
        return `${year}${month}${day}`
      }

      console.log(formattedYesterday) // 输出格式化后的前一天日期
    },
    //设置k线图
    setkLine(val, period) {
      let params = {
        symbol: "sh600519",
        period,
        startDate: 20150101, //20250319
        endDate: this.getToday(0),
      }
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let innerCodeList = this.getFidData()
      this.setCode().forEach(async (item, index) => {
        params.symbol = dealCodeSearch(item, { routeId: "1" })
        let imgSrc = ""
        let url = "/tradelab"
        let resData = {}
        switch (period) {
          case "d":
            params.startDate = this.getTime(90)
            imgSrc = `${url}/ai/finance/kline?symbol=${params.symbol}&period=${period}&startDate=${params.startDate}&endDate=${params.endDate}`
            let data = {
              innerCode: innerCodeList[index],
              startDate: this.getToday(1),
            }
            let res = await findStockDetail(data)
            resData = res.data[0] || {}
            break
          case "w":
            params.startDate = this.getTime(365)
            imgSrc = `${url}/ai/finance/kline?symbol=${params.symbol}&period=${period}&startDate=${params.startDate}&endDate=${params.endDate}`
            break
          case "m":
            params.startDate = this.getTime(1825)
            imgSrc = `${url}/ai/finance/kline?symbol=${params.symbol}&period=${period}&startDate=${params.startDate}&endDate=${params.endDate}`
            break
          case "y":
            params.startDate = 19991201
            imgSrc = `${url}/ai/finance/kline?symbol=${params.symbol}&period=${period}&startDate=${params.startDate}&endDate=${params.endDate}`
            break
          case "股票交易资金流向":
            // var imgData= await getfundflow({symbol:params.symbol})
            // var blob = new Blob([imgData.data], { type: imgData.headers['content-type'] })
            //  imgSrc =URL.createObjectURL(blob)
            imgSrc = `${url}/ai/finance/fundflow?symbol=${params.symbol}`
            break

          default:
            break
        }

        val.editor.cmd.do(
          "insertHTML",
          `<br><div style="text-align:center;    display: flex;
      flex-direction: column; 
      justify-content: center;
      align-items: center;width:100%;">${
        period == "d" && resData ? stockInfo(resData) : ""
      }<img style="width:50%;display:block;" src="${imgSrc}"/></div>`
        )
      })
    },
    //停牌复牌表
    setFindByTradingHaltInfo(val) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let tableData = []
      let data = {
        innerCodes: this.getFidData(),
      }
      let column = [
        // { label: "ID", prop: "id" },
        { label: "内部编码", prop: "innerCode", isNmuber: true },
        { label: "信息发布日期", prop: "infoPublDate", date: true },
        { label: "信息来源", prop: "infoSource" },
        { label: "停牌日期", prop: "suspendDate", date: true },
        { label: "停牌时间", prop: "suspendTime", date: true },
        { label: "停牌原因", prop: "suspendStatement" },
        { label: "停牌事项说明", prop: "suspendStatement" },
        { label: "停牌期限", prop: "suspendTerm" },
        { label: "复牌日期", prop: "resumptionDate", date: true },
        { label: "复牌时间", prop: "resumptionTime", date: true },
        { label: "复牌事项说明", prop: "resumptionStatement" },
        { label: "更新时间", prop: "updateTime", date: true },
        // { label: "JSID", prop: "jsId",isNmuber:true },
      ]
      findByTradingHaltInfo(data).then((res) => {
        if (res.status == 200) {
          tableData = res.data
          if(!(res.data&&res.data.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
          val.editor.cmd.do(
            "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
            findByBlockTradeTable(tableData, column)
          )
        }
      })
    },

    //复权因子表

    setFindByAdjustingFactor(val) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let tableData = []
      let data = {
        innerCodes: this.getFidData(),
      }
      let column = [
        // { label: "ID", prop: "id" },
        { label: "除权除息日", prop: "exDiviDate", date: true },
        { label: "证券内部编码", prop: "innerCode", isNmuber: true },
        { label: "精确复权因子", prop: "adjustingFactor" },
        { label: "精确复权常数", prop: "adjustingConst" },
        { label: "比例复权因子", prop: "ratioAdjustingFactor" },
        { label: "累计分红", prop: "accuCashDivi" },
        { label: "累计送股", prop: "accuBonusShareRatio" },
        { label: "更新时间", prop: "updateTime", date: true },
        // { label: "JSID", prop: "jsId",isNmuber:true },
      ]
      findByAdjustingFactor(data).then((res) => {
        if (res.status == 200) {
          tableData = res.data
          if(!(res.data&&res.data.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
          val.editor.cmd.do(
            "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
            findByBlockTradeTable(tableData, column)
          )
        }
      })
    },

    setByTradingPost(val) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let tableData = []
      let data = {
        innerCodes: this.getFidData(),
        startDate: 20200101,
      }
      let column = [
        // { label: "ID", prop: "id" },
        { label: "证券内部代码", prop: "innerCode", isNmuber: true },
        { label: "信息来源", prop: "infoSource" },
        { label: "异动类型", prop: "abnormalType" },
        { label: "交易起始日期", prop: "tradingStartDate", date: true },
        { label: "交易(截止)日期", prop: "tradingDay", date: true },
        { label: "序号", prop: "serialNum" },
        { label: "营业部名称", prop: "salesDepartmentName" },
        { label: "营业部编号", prop: "bocode" },
        { label: "营业部所属券商编号", prop: "secuCoBelongedCode" },
        { label: "营业部所属券商", prop: "secuCoBelonged" },
        { label: "成交量(股)", prop: "turnoverVolume" },
        { label: "成交金额(元)", prop: "turnoverValue" },
        { label: "涨跌幅", prop: "changePCT" },
        { label: "涨跌幅偏离值", prop: "changePCTOffset" },
        { label: "振幅", prop: "fluctuatingAmptitude" },
        { label: "换手率", prop: "turnoverRate" },
        { label: "成交占比(%)", prop: "turnoverProp" },
        { label: "买卖合计金额(元)", prop: "totalBuySaleSum" },
        { label: "买入金额(元)", prop: "buySum" },
        { label: "卖出金额(元)", prop: "saleSum" },
        { label: "统计方式", prop: "statType" },
        { label: "更新时间", prop: "xgrq", date: true },
      ]

      findByTradingPost(data).then((res) => {
        if (res.status == 200) {
          tableData = res.data
          if(!(res.data&&res.data.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
          val.editor.cmd.do(
            "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
            findByBlockTradeTable(tableData, column)
          )
        }
      })
    },
    setCode() {
      let list = []
      if (this.isEdit) {
       
        list = this.codeList.map((item) => {
          console.log(item, "items")
          return item.sharesName.split("_")[0]
        })
      } else {
        list = this.codeList
      }
      return list
    },
    getFidData() {
      let innerCodes = []
      this.setCode().forEach((item) => {
        let allcodeList = JSON.parse(localStorage.getItem("all"))
        let fidData = allcodeList.find((elem) => elem.fgsid == item)
        innerCodes.push(fidData.fid.trim())
      })
      return innerCodes
    },
    setByZzIndustry(val) {
      let tableData = []
      let column = [
        { label: "信息发布日", prop: "infoPublDate", date: true },
        { label: "交易日期", prop: "tradingDate", date: true },
        // { label: "统计类型", prop: "statType", isNmuber: true },
        // { label: "行业分类标准", prop: "ics", isNmuber: true },
        // { label: "统计指标", prop: "statRatio", isNmuber: true },
        // { label: "证券/行业/板块代码", prop: "secuCode", isNmuber: true },
        { label: "证券/行业/板块名称", prop: "secuName" },
        // {
        //   label: "个股所属证监会行业分类代码",
        //   prop: "csrcIndusCode",
        //   isNmuber: true,
        // },
        // {
        //   label: "个股所属证监会行业分类内码",
        //   prop: "csrcInnerCode",
        //   isNmuber: true,
        // },
        // {
        //   label: "个股所属中证行业分类代码",
        //   prop: "csiIndusCode",
        //   isNmuber: true,
        // },
        // {
        //   label: "个股所属中证行业分类内码",
        //   prop: "csiInnerCode",
        //   isNmuber: true,
        // },
        { label: "每日最新", prop: "rd", isNmuber: true },
        { label: "最近一月平均", prop: "rm" },
        { label: "最近三月平均", prop: "r3m" },
        { label: "最近六月平均", prop: "r6m" },
        { label: "最近一年平均", prop: "r12m" },
        { label: "股票总家数", prop: "numOfComp" },
        { label: "剔除股票类型", prop: "typeEx" },
        { label: "剔除股票家数", prop: "numOfCompEx" },
        { label: "信息发布机构", prop: "infoPublInst", isNmuber: true },
        { label: "更新时间", prop: "updateTime", date: true },
        // { label: "JSID", prop: "jsid" ,isNmuber:true},
      ]
      if (!this.industry) {
        ElMessage.warning("请选择行业类型")
        return
      }
      findByZzIndustry({
        innerCode:this.isEdit? this.industry.industryNum:this.industry, //this.getFidData(),
        startDate: "2023-01-01",
      }).then((res) => {
        if (res.status == 200) {
          tableData = res.data
          if(!(res.data&&res.data.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
          val.editor.cmd.do(
            "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
            findByBlockTradeTable(tableData, column)
          )
        }
      })
    },
    //深证
    setBySzIndustry(val) {
      let tableData = []
      let column = [
        { label: "信息发布日期", prop: "infoPublDate", date: true },
        { label: "信息发布机构", prop: "infoPublInst" },
        { label: "交易日期", prop: "tradingDay", date: true },
        { label: "行业分类标准", prop: "industryStd" },
        // { label: "统计板块", prop: "sectorCode" },
        // { label: "行业分类代码", prop: "industryCode", isNmuber: true },
        // { label: "行业分类内码", prop: "innerCode", isNmuber: true },
        { label: "行业名称", prop: "industryName" },
        { label: "股票总家数", prop: "numOfComp" },
        { label: "静态市盈率加权平均数", prop: "lyrAvgPe",width:'150px' },
        { label: "静态市盈率中位数", prop: "lyrMidPe" ,width:'140px'},
        { label: "滚动市盈率加权平均数", prop: "ttmMedPe",width:'150px' },
        { label: "滚动市盈率中位数", prop: "ttmMedPe",width:'140px' },
        { label: "更新时间", prop: "updateTime", date: true },
        // { label: "JSID", prop: "jsid" ,isNmuber:true },
      ]
      if (!this.industry) {
        ElMessage.warning("请选择行业类型")
        return
      }
      findBySzIndustry({
        innerCode: this.isEdit? this.industry.industryNum:this.industry, //this.getFidData(),
        startDate: "2023-01-01",
      }).then((res) => {
        if (res.status == 200) {
          tableData = res.data
          if(!(res.data&&res.data.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
          val.editor.cmd.do(
            "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
            findByBlockTradeTable(tableData, column)
          )
        }
      })
    },

    setByBlock(val) {
      if (this.setCode().length == 0) {
        ElMessage.warning("至少选择一个证券代码")
        return
      }
      let tableData = []
      let column = [
        { label: "代码", prop: "innerCode", isNmuber: true },
        { label: "交易日期", prop: "tradingDay", date: true },
        { label: "买卖方向", prop: "bsdirection" },
        { label: "买卖方向代码", prop: "bsdirectionCode" },
        { label: "价格(元)", prop: "bsprice" },
        { label: "数量(万股)", prop: "bsvolume" },
        { label: "备注", prop: "remark" },
        { label: "更新时间", prop: "updateTime", date: true },
      ]
      findByBlockTrade({
        innerCodes: this.getFidData(),
        startDate: "20100101",
      }).then((res) => {
        if (res.status == 200) {
          tableData = res.data
          if(!(res.data&&res.data.length>0)){
            ElMessage.warning("暂无数据")
            return
          }
          val.editor.cmd.do(
            "insertHTML",`<h3 style="text-align:center;">${this.period}</h3>`+
            findByBlockTradeTable(tableData, column)
          )
        }
      })
    },
    onChange(newHtml) {
      ;``
      this.$emit("valueChange", newHtml)
    },
  },
}
</script>

<style lang="less">
#TextEditor {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #f0f2f5;
  margin-top: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);

  #TextEditorNav {
    height: 40px;
    width: 100%;
    .w-e-toolbar {
      background-color: #fff;
      border-bottom:1px solid #eee;
    }
  }

  #TextEditorMain {
    flex: 1;
    width: 100%;
    /*margin-top: 10px;*/
    /*margin-bottom: 10px;*/
    display: flex;
    justify-content: space-around;

    #TextEditorMainCode,
    #TextEditorMainShow {
      width: 100%;
      height: 40vh;
      min-height: 400px;
      .w-e-text-container {
        height: 40vh;
        min-height: 400px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      }
    }
  }

  .toolbar {
    border: 1px solid #ccc;
  }

  .text {
    border: 1px solid #ccc;
    min-height: 400px;
  }
}

.w-e-menu[data-title="结构化图表"] {
  // width: 16px;
  // height: 16px;

  .w-e-droplist {
    width: 189px !important;
  }
  .w-line {
    width: 16px;
    height: 16px;
    background-image: url(../../assets/折线图.png);
    background-size: 100% 100%;
  }
}
.is-compact  .w-e-menu[data-title="结构化图表"]{
  .w-e-list {
     .w-e-item:nth-child(9), .w-e-item:nth-child(8){
      display: none;
     }
  }

}
.w-e-menu[data-title="替换"] {
  // width: 16px;
  // height: 16px;

  .w-line {
    width: 20px;
    height: 20px;
    background-image: url(../../assets/ai.png);
    background-size: 100% 100%;
   
  }
}
.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item {
  text-align: left;
  padding-left: 15px;
}
.w-e-item {
  padding-left: 12px !important;
}
</style>
